import { CartContext } from '@contexts/CartContext';
import { HeaderFastActionItem } from '@lib/types/cms/Header';
import { ForwardedRef, useContext } from 'react';
import { IconWithCount } from 'ui-components';
import { IconMenuOption } from '../Header/IconMenuOption';

type FastActionMenuCartProps = {
  item: HeaderFastActionItem;
  forwardedRef: ForwardedRef<HTMLDivElement>;
  referenceProps: {};
};

export const FastActionMenuCart = ({
  item,
  forwardedRef,
  referenceProps,
}: FastActionMenuCartProps) => {
  const { cart } = useContext(CartContext);
  const itemCount = cart?.ItemCount || 0;
  // TODO: Translate the text
  const cartAriaLabel = `View ${item.topLevelLink?.value} (${itemCount} item${itemCount === 1 ? '' : 's'})`;
  return (
    <IconMenuOption
      name={cartAriaLabel}
      href={item.topLevelLink?.url || ''}
      ref={forwardedRef}
      {...referenceProps}
      className="relative rounded-full"
      target={item.topLevelLink?.openInNewTab ? '_blank' : undefined}
    >
      <IconWithCount
        iconName={item.topLevelLink?.icon || ''}
        iconSize={20}
        count={cart?.ItemCount || 0}
      />
    </IconMenuOption>
  );
};
